import { render, staticRenderFns } from "./CollapseBodyCard.vue?vue&type=template&id=8551adde&"
import script from "./CollapseBodyCard.vue?vue&type=script&lang=js&"
export * from "./CollapseBodyCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports